//
//
//
//
//
//
//
//
//
//
//

import EventTransfer from '@/components/eventTransfer';
import EventTip from '@/components/eventTip';

export default {
  name: 'WorkflowDetailAddEvent',
  components: { EventTransfer, EventTip },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      actionList: [],
    };
  },
  watch: {
    // 已经选择的当前数据要展示在弹框内
    visible(val) {
      if (val) {
        this.actionList = this.selected.map((i) => i.id);
      }
    },
  },
  methods: {
    success() {
      this.$emit('success', this.actionList);
    },
    close() {
      this.actionList = [];
      this.$emit('close');
    },
  },
};
